import { forwardRef, Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanDeactivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Store } from '@ngrx/store';
import { ColdSubject } from 'app/core/guards/cold-subject';
import * as fromRoot from 'app/core/store';
import { CalendarOrdersClearStateAction } from 'app/core/store/calendar/orders/calendar-orders.actions';
import { CalendarRelocationsClearStateAction } from 'app/core/store/calendar/relocations/calendar-relocations.actions';
import { logger } from 'app/core/util/logger';
import { Observable } from 'rxjs';

/**
 * Guard to synchronously clear orders filter & result
 */
@Injectable({ providedIn: 'root' })
export class CalendarClearStateUnguard implements CanDeactivate<any> {
  private store: Store<fromRoot.RootState>;

  constructor(@Inject(forwardRef(() => Store)) store) {
    this.store = store;
  }

  canDeactivate(
    component: any,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
    logger.debug(`In CalendarClearStateUnguard`);
    return new ColdSubject(subject => {
      logger.debug('In ClearInvoicesFilterGuard');
      // with timeout of 3 seconds to avoid viewing an empty calendar whilst waiting for other guards to finish before leaving the page
      setTimeout(() => {
        this.store.dispatch(new CalendarOrdersClearStateAction());
        this.store.dispatch(new CalendarRelocationsClearStateAction());
      }, 3000);
      return true;
    });
  }
}
